const zoomElements = document.querySelectorAll(".pinch-effect")

let firstTouch = 0;
let pinchVariable = 1;
let lastDragPosition = false;
let initialX = 0;
let initialY = 0;

function calculateDragBorders(zoomedImg,pinchVariable) {
    let maxX = (zoomedImg.width * (pinchVariable-1)) / 5;
    let maxY = (zoomedImg.height * (pinchVariable-1)) / 5;

    if (maxX < 0 && maxY < 0) {
        return [maxX,maxY,maxX*-1,maxY*-1]
    } else if (maxX < 0 && maxY > 0) {
        return [maxX,maxY*-1,maxX*-1,maxY]
    } else if (maxX > 0 && maxY < 0) {
        return [maxX*-1,maxY,maxX,maxY*-1]
    } else if (maxX > 0 && maxY > 0) {
        return [maxX*-1,maxY*-1,maxX,maxY]
    }
}

function touchDistance(event) {
    var distance = Math.hypot(event.touches[0].pageX - event.touches[1].pageX, event.touches[0].pageY - event.touches[1].pageY);
    return distance;
}

function touchPositionPinch(newPosition,lastPosition,scaleValue) {
    let xPositionChange = 0
    let yPositionChange = 0

    let firstXChange = newPosition.firstX - lastPosition.firstX;
    let secondXChange = newPosition.secondX - lastPosition.secondX;
    let firstYChange = newPosition.firstY - lastPosition.firstY;
    let secondYChange = newPosition.secondY - lastPosition.secondY;
    let draggedX = (firstXChange * secondXChange) > 0;
    let draggedY = (firstYChange * secondYChange) > 0;
    if (draggedX) {
        xPositionChange = Math.abs(firstXChange) < Math.abs(secondXChange) ? firstXChange : secondXChange;
    }
    if (draggedY) {
        yPositionChange = Math.abs(firstYChange) < Math.abs(secondYChange) ? firstYChange : secondYChange;
    }
    return [xPositionChange/scaleValue,yPositionChange/scaleValue]
}

function touchPositionSlide(newPosition,lastPosition,scaleValue) {
    let xPositionChange = 0
    let yPositionChange = 0

    let firstXChange = newPosition.firstX - lastPosition.firstX;
    let firstYChange = newPosition.firstY - lastPosition.firstY;

    if (firstXChange != 0) {
        xPositionChange = firstXChange;
    }
    if (firstYChange != 0) {
        yPositionChange = firstYChange;
    }
    return [xPositionChange/scaleValue,yPositionChange/scaleValue]
}

zoomElements.forEach((e)=>e.addEventListener("touchstart",(event)=>{
    let zoomedImg = event.target

    if (event.touches.length === 2) {
        event.preventDefault()
        $(zoomedImg).parents(".slick-slider")[0].slick.slickSetOption("swipe",false)
        $(zoomedImg).css("touch-action", "none")
        firstTouch = touchDistance(event)
        lastDragPosition = {
            "firstX": event.touches[0].pageX,
            "secondX": event.touches[1].pageX,
            "firstY":event.touches[0].pageY,
            "secondY":event.touches[1].pageY,
            "xPosition": initialX,
            "yPosition": initialY
        }
    } else {
        lastDragPosition = {
            "firstX": event.touches[0].pageX,
            "firstY":event.touches[0].pageY,
            "xPosition": initialX,
            "yPosition": initialY
        }
    }
}))

zoomElements.forEach((e)=>e.addEventListener("touchmove",(event)=>{
    let zoomedImg = event.target
    if (event.touches.length === 2) {
        $(zoomedImg).parents(".slick-slider")[0].slick.slickSetOption("swipe",false)
        $(zoomedImg).css("touch-action", "none")
        let secondTouch = touchDistance(event)
        let scaleValue = (secondTouch/firstTouch)
        if (scaleValue > 1 && scaleValue < 2.5 ) {
            zoomedImg.style.setProperty('--pinchScale', scaleValue); 
            pinchVariable = scaleValue;
        } else if (scaleValue >= 2.5) {
            zoomedImg.style.setProperty('--pinchScale', 2.5); 
            pinchVariable = 2.5;
        } else  {
            zoomedImg.style.setProperty('--pinchScale', 1);
            pinchVariable = 1;
        }

        let currentDragPosition = {
            "firstX": event.touches[0].pageX,
            "secondX": event.touches[1].pageX,
            "firstY":event.touches[0].pageY,
            "secondY":event.touches[1].pageY
        }
        let positionChanges = touchPositionPinch(currentDragPosition,lastDragPosition,pinchVariable)

        zoomedImg.style.setProperty('--pinchX', positionChanges[0]+lastDragPosition.xPosition + 'px');
        zoomedImg.style.setProperty('--pinchY', positionChanges[1]+lastDragPosition.yPosition + 'px');

        lastDragPosition = {
            "firstX": event.touches[0].pageX,
            "secondX": event.touches[1].pageX,
            "firstY":event.touches[0].pageY,
            "secondY":event.touches[1].pageY,
            "xPosition": positionChanges[0]+lastDragPosition.xPosition,
            "yPosition": positionChanges[1]+lastDragPosition.yPosition
        }
    } else if (pinchVariable >= 2.5) {
        let currentDragPosition = {
            "firstX": event.touches[0].pageX,
            "firstY":event.touches[0].pageY,
        }
        let positionChanges = touchPositionSlide(currentDragPosition,lastDragPosition,pinchVariable)

        zoomedImg.style.setProperty('--pinchX', positionChanges[0]+lastDragPosition.xPosition + 'px');
        zoomedImg.style.setProperty('--pinchY', positionChanges[1]+lastDragPosition.yPosition + 'px');
        
        lastDragPosition = {
            "firstX": event.touches[0].pageX,
            "firstY":event.touches[0].pageY,
            "xPosition": positionChanges[0]+lastDragPosition.xPosition,
            "yPosition": positionChanges[1]+lastDragPosition.yPosition
        }
    }
}))

zoomElements.forEach((e)=>e.addEventListener("touchend",(event)=>{
    let zoomedImg = event.target
    if (pinchVariable >= 2) {
        $(zoomedImg).parents(".slick-slider")[0].slick.slickSetOption("swipe",false)
        $(zoomedImg).css("touch-action", "none")
        pinchVariable = 2.5;
        zoomedImg.style.setProperty('--pinchScale', 2.5);

        let dragBorders = calculateDragBorders(zoomedImg,pinchVariable)


        if (lastDragPosition.xPosition > dragBorders[2]) {
            zoomedImg.style.setProperty('--pinchX', dragBorders[2] + 'px');
            initialX = dragBorders[2]
        } else if (lastDragPosition.xPosition < dragBorders[0]) {
            zoomedImg.style.setProperty('--pinchX', dragBorders[0] + 'px');
            initialX = dragBorders[0]
        } else {
            zoomedImg.style.setProperty('--pinchX', lastDragPosition.xPosition + 'px');
            initialX = lastDragPosition.xPosition;
        }        

        if (lastDragPosition.yPosition > dragBorders[3]) {
            zoomedImg.style.setProperty('--pinchY', dragBorders[3] + 'px');
            initialY = dragBorders[3]
        } else if (lastDragPosition.yPosition < dragBorders[1]) {
            zoomedImg.style.setProperty('--pinchY', dragBorders[1] + 'px');
            initialY = dragBorders[1]
        } else {
            zoomedImg.style.setProperty('--pinchY', lastDragPosition.yPosition + 'px');
            initialY = lastDragPosition.yPosition;
        }
    } else {
        $(zoomedImg).parents(".slick-slider")[0].slick.slickSetOption("swipe",true)
        $(zoomedImg).css("touch-action", "auto")
        zoomedImg.style.setProperty('--pinchScale', 1);
        pinchVariable = 1;
        zoomedImg.style.setProperty('--pinchX', '0px');
        zoomedImg.style.setProperty('--pinchY', '0px');
        initialX = 0;
        initialY = 0;
    }
}))